import React from 'react';
import logo from '../images/mcn-logo.svg';

const BrandLogo = () => (
    <img
        className="mcn-brand-logo"
        src={logo}
        alt="MCN Technologies"
        width="168"
        height="86"
        decoding="async"
    />
);

export default BrandLogo;
